import React from 'react';
import { C } from '../constants/theme';

export const inputStyle = {
  width: '100%',
  border: `1px solid ${C.border}`,
  borderRadius: 8,
  padding: '9px 12px',
  fontSize: 14,
  color: C.text,
  background: C.white,
  boxSizing: 'border-box',
  outline: 'none',
  transition: 'border-color .15s',
  fontFamily: 'inherit',
};

export const selectStyle = { ...inputStyle, cursor: 'pointer' };

export function FormField({ label, children, required, col }) {
  return (
    <div style={{ gridColumn: col ? `span ${col}` : undefined }}>
      <label style={{
        display: 'block', fontSize: 12, fontWeight: 600,
        color: C.textMuted, marginBottom: 4,
        textTransform: 'uppercase', letterSpacing: 0.5,
      }}>
        {label}
        {required && <span style={{ color: C.danger }}> *</span>}
      </label>
      {children}
    </div>
  );
}
